import { Icon } from "@mdi/react";
import React from "react";

import { mdiContentCopy } from "@mdi/js";

import { useAutomationBroker } from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { SetChartPayload, SettingsProps } from "components/automation/types/payloads";
import { ChartSettingsResult } from "components/automation/types/results";
import { Topics } from "components/automation/types/topics";

import { StyledContainer, StyledCopyButton, StyledLabelValue } from "./shared";

export const SetChartSettings: React.FC<SettingsProps<SetChartPayload>> = ({
  value,
  onChange
}) => {
  const broker = useAutomationBroker();
  const handleCopySettings = async () => {
    if (value) {
      const results = await broker.executeCommands([
        {
          id: "get settings",
          topic: Topics.GetChartSettings,
          delay: 200
        } as AutomationCommand
      ]);
      if (results.length > 0) {
        const chartSettings = results[0] as ChartSettingsResult;
        //remove the apiResponse from the chartSettings since it contains a lot of data
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { apiResponse: _, ...sanitizedSettings } = chartSettings.settings as {
          apiResponse: unknown;
        };
        onChange(sanitizedSettings as SetChartPayload);
      }
    }
  };
  return (
    <StyledContainer>
      <StyledCopyButton
        type="default"
        size="large"
        onClick={handleCopySettings}
        icon={<Icon path={mdiContentCopy} size={1.2} />}>
        Copy Settings From Chart
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Chart Type:</span>
        <span className="value">{value?.chartType ?? ""}</span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Product:</span>
        <span className="value">{value?.product ?? ""}</span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Forecast:</span>
        <span className="value">{value?.forecast?.active ? "On" : "Off"}</span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Focus:</span>
        <span className="value">
          {value?.chartFocus?.enabled && value?.chartFocus?.active
            ? value?.chartFocus?.properties?.groupBy?.title ?? ""
            : "Global Setting"}
        </span>
      </StyledLabelValue>

      <StyledLabelValue>
        <span className="label">Normalize By:</span>
        <span className="value">
          {value?.normalizeBy?.show && value?.normalizeBy?.active
            ? value?.normalizeBy?.properties?.displayName ?? ""
            : "Off"}
        </span>
      </StyledLabelValue>
    </StyledContainer>
  );
};
